/**
 * Constantes y tipos de rangos de fechas compartidos entre Informes, POS y consultas de ventas.
 */

export type DateRangePreset =
  | 'today'
  | 'yesterday'
  | 'week' // semana calendario — la usa la card "Esta semana" del home, no es chip de período
  | 'last_7_days'
  | 'last_30_days'
  | 'this_month'
  | 'last_month'
  | 'last_12_months'
  | 'custom';

export const DATE_RANGE_PRESETS = [
  'today',
  'yesterday',
  'last_7_days',
  'last_30_days',
  'this_month',
  'last_month',
  'last_12_months',
  'custom',
] as const;

/** Presets en historial de ventas del POS (chips compactos — mismo set que el picker de período). */
export const POS_SALES_HISTORY_DATE_PRESETS = [
  'today',
  'yesterday',
  'last_7_days',
  'this_month',
  'last_month',
] as const satisfies readonly DateRangePreset[];

export const DATE_RANGE_PRESET_LABELS: Record<DateRangePreset, string> = {
  today: 'Hoy',
  yesterday: 'Ayer',
  week: 'Esta semana',
  last_7_days: 'Últimos 7 días',
  last_30_days: 'Últimos 30 días',
  this_month: 'Este mes',
  last_month: 'Mes anterior',
  last_12_months: 'Últimos 12 meses',
  custom: 'Personalizado',
};
